import React, { FC, SyntheticEvent, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { hideTooltipsAction } from 'actions/tooltipAction'
import { PhotoViewerParams } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { TooltipMenuViewCurrentUser } from 'components/page/PhotoViewer/TooltipMenu/TooltipMenuViewCurrentUser'
import { TooltipMenuViewUser } from 'components/page/PhotoViewer/TooltipMenu/TooltipMenuViewUser'
import { photoMenuTooltipId } from 'components/page/UserProfile/constants'
import { push } from 'functions/router'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useTooltip } from 'hooks/useTooltip'

export const TooltipMenu: FC<{
  selectedPhotoIndex: number
}> = ({ selectedPhotoIndex }) => {
  const dispatch = useDispatch()
  const { userId } = useParams<PhotoViewerParams>()
  const {
    userId: currentUserId,
    authorized,
    photos,
  } = useShallowEqualSelector(
    ({
      userReducer: { userId },
      authorizationReducer: { authorized },
      photoViewerReducer: { photos },
    }) => ({
      userId,
      authorized,
      photos,
    })
  )
  const [tooltipState, toggleTooltipState] = useTooltip(photoMenuTooltipId)
  const isCurrentUser = currentUserId === Number(userId)
  const authorizationPath = useAuthorizationPath()
  const openAuthorization = () => dispatch(push(authorizationPath))

  const photoId = photos[selectedPhotoIndex].photoId

  const handleMenuClick = (event: SyntheticEvent) => {
    if (authorized) {
      toggleTooltipState(event)
    } else {
      openAuthorization()
    }
  }

  useEffect(() => {
    return () => {
      dispatch(hideTooltipsAction())
    }
  }, [selectedPhotoIndex])

  if (isCurrentUser) {
    return (
      <TooltipMenuViewCurrentUser
        selectedPhotoIndex={selectedPhotoIndex}
        tooltipState={tooltipState}
        onHandleMenuClick={handleMenuClick}
      />
    )
  }

  return (
    <TooltipMenuViewUser
      userId={userId}
      photoId={photoId}
      onHandleMenuClick={handleMenuClick}
      tooltipState={tooltipState}
    />
  )
}
